import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Observable, of, Subscription } from "rxjs";
import { catchError, finalize, map, switchMap, take } from "rxjs/operators";
import {
  SiteWarehouseDTO,
  TankStockDTO,
  WarehouseType,
} from "src/app/models/Sites/siteWarehouseDTO";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import { TenantDataFormatDTO } from "src/app/models/Tenant/Tenant.model";
import { DashboardService } from "src/app/shared/services/dashboard/dashboard.service";
import { SitesService } from "src/app/shared/services/sites/sites.service";
import { SnackBarUtils } from "src/app/shared/utils/snackbarUtils";
import { setSnackbar } from "src/app/store/actions/messages/message.actions";
import {
  AppState,
  loadedTenantState,
  siteWarehousesLoadedState,
  warehouseTypesLoadedState,
} from "src/app/store/reducers";

@Component({
  selector: "app-wetstock-row-detail",
  templateUrl: "./wetstock-row-detail.component.html",
  styleUrls: ["./wetstock-row-detail.component.scss"],
})
export class WetstockRowDetailComponent implements OnInit, OnDestroy {
  private _row: any;
  
  @Input() set row(value: any) {
    this._row = value;
    if (value?.code) {
      this.loadingWarehouses = true;
      this.warehouseSub?.unsubscribe();
      this.warehouseList = [];
      this.currentWarehouse = null;
      this.tankStock = [];

      this.loadSiteWarehouses(value.code);
    }
  }
  get row() {
    return this._row;
  }

  public tenantDataFormat!: TenantDataFormatDTO;
  public warehouseType: string = 'WET';

  //Tenant Data
  tenantDataSub: Subscription;
  tenantData$: Observable<any>;

  //Wareouse List
  warehouseList$: Observable<SiteWarehouseDTO[]>;
  warehouseList: SiteWarehouseDTO[] = [];

  //Warehouse Type list
  warehouseTypeList$: Observable<WarehouseType[]>;
  warehouseTypeList: WarehouseType[];

  //Subscriptions
  warehouseSub: Subscription;

  loadingWarehouses = false;

  currentWarehouse: SiteWarehouseDTO;

  tankStock: { value: TankStockDTO }[];

  constructor(
    private dashboardService: DashboardService,
    private sitesService: SitesService,
    private store: Store<AppState>,
    private translate: TranslateService,
    private router: Router
  ) {
    this.tenantData$ = this.store.pipe(select(loadedTenantState));
    this.warehouseTypeList$ = this.store.pipe(
      select(warehouseTypesLoadedState)
    );
    this.warehouseList$ = this.store.pipe(select(siteWarehousesLoadedState));
  }

  ngOnInit(): void {
    this.loadTenantData();
  }

  loadTenantData(): void {
    this.tenantDataSub = this.tenantData$.subscribe((data: any) => {
      if (data) {
        this.tenantDataFormat = data;
      }
    });
  }

  loadSiteWarehouses(code: string) {
    const stockDashboardPayload = {
      type: 'PROBE_MEASUREMENTS_BY_ONE_SITE',
      range: {},
      filters: { site_number: [this.row.siteNumber] },
    };

    this.warehouseSub = this.dashboardService.getDashboardSalesV2(stockDashboardPayload).pipe(
      switchMap((result: any) => {
        if (code !== this._row?.code) return of<SiteWarehouseDTO[]>([]);
        this.tankStock = result?.series ?? [];

        return this.sitesService
          .getSiteWarehouses(code, { realSize: true, offset: 0, limit: 999 })
          .pipe(
            take(1),
            map((resp: any) => resp?.result?.items ?? resp ?? []), // unwrap
          );
      }),
      catchError(() => {
        this.store.dispatch(
          setSnackbar(
            SnackBarUtils.setSnackBar(
              this.translate.instant('TankLevel.loadFuelStockDashboardError'),
              SnackbarType.ERROR
            )
          )
        );
        return of<SiteWarehouseDTO[]>([]);
      }),
      finalize(() => {
        if (code === this._row?.code) this.loadingWarehouses = false;
      })
    ).subscribe((warehouses: any[] = []) => {
      if (code !== this._row?.code) return;

      if (!Array.isArray(warehouses)) warehouses = [];

      const filtered = (warehouses ?? [])
        .filter(({ warehouseTypeCode }) => warehouseTypeCode === this.warehouseType)
        .map((warehouse) => {
          const tankStock = this.tankStock?.find((serie) => serie?.value?.warehouseCode === warehouse.code);
          return tankStock?.value ? { ...warehouse, tankStock: tankStock.value } : warehouse;
        });

      this.warehouseList = filtered;

      if (this.currentWarehouse) {
        const { code: currentWarehouseCode } = this.currentWarehouse;
        this.currentWarehouse = filtered.find(({ code }) => code === currentWarehouseCode) || null;
      }
    });
  }

  onCardSelect(wetstock: SiteWarehouseDTO) {
    const {
      stockStatus: [{ code }],
    } = wetstock;

    if(!code) {
      return;
    }
    this.router.navigate(
      ["/fuelStocks/fuelStock", code],
      {
        state: {
          openWetstockTab: true,
          // warehouse: wetstock, 
          // tenantDataFormat: this.tenantDataFormat
        },
      }
    )
  }

  ngOnDestroy(): void {
    this.tenantDataSub?.unsubscribe();
    this.warehouseSub?.unsubscribe();
  }
}
